import Vue from 'vue'
import App from './App.vue'
import router from './router';
Vue.config.productionTip = false

// 引入echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
// 导入DataV
import { decoration7 } from '@jiaminghi/data-view'
// Datav组件
Vue.use(decoration7)
// 分页组件
import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination)

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import dataV from '@jiaminghi/data-view'

Vue.use(dataV)

new Vue({
  router,
  render: h => h(App),
  data: function () {
    return{
      BASE_URL: "/api",
      // BASE_URL: "http://192.168.31.38:2023",
    }
  }
}).$mount('#app')

